// extracted by mini-css-extract-plugin
export default {"overlay":"config__overlay___daCNz","controlRow":"config__controlRow___sgVGO","controlLabel":"config__controlLabel___p2LwN"};